import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X5LessonStore} from '../X5LessonStore';

@observer
export class DeletePageControls extends React.Component<{ store: X5LessonStore }> {
  render() {
    const {store} = this.props;

    if (store.deletePage === null)
      return null;

    const deletePage = store.deletePage;
    const isFailure = deletePage.save?.isRejected === true;

    return (<>
      <PromiseMessage label="Deleting" state={deletePage.save} align="right"/>

      {
        isFailure &&
        <div className="row justify-content-end">
          <div className="col-auto">
            <button type="button" className="btn btn-primary"
                    onClick={() => store.beginDeletePage(deletePage.pageId)}> Retry
            </button>
            <button type="button" className="btn btn-primary"
                    onClick={store.cancel}> Cancel
            </button>
          </div>
        </div>
      }
    </>);
  }
}
